import React from 'react';
import s from '../../pages/PDV.module.css';
import api from '../../services/api';
import { calcularPrecoTabela } from '../../utils/precoTabela';

const fmtBRL = v =>
  Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default function ModalBuscaProdutos({ modalF3, fecharF3, filtrosF3, setFiltro, setFiltrosF3, FILTROS_VAZIOS, produtosF3, setProdutosF3, buscaRapidaF3, setBuscaRapidaF3, handleBuscaRapidaF3, buscandoF3, buscarF3, idxF3, setIdxF3, confirmarF3, tipoMovFiscal, buscaRapidaRef, consultaOnly = false, tabela = null, modoTodos = false, confirmarTodos, avancado = false, selecao = false, confirmarSelecionados, totalF3 = 0 }) {
  // Mantém a linha selecionada visível ao navegar com as setas
  const linhaSelRef = React.useRef(null);
  React.useEffect(() => {
    linhaSelRef.current?.scrollIntoView?.({ block: 'nearest' });
  }, [idxF3]);

  // Listas dos selects de Grupo/Subgrupo/Marca/Fornecedor/Unidade — só
  // carregadas na Busca Avançada (avancado=true), e só quando o modal abre
  // (evita chamada à toa nas telas que usam a versão enxuta, tipo PDV).
  const [grupos, setGrupos]             = React.useState([]);
  const [subgrupos, setSubgrupos]       = React.useState([]);
  const [marcas, setMarcas]             = React.useState([]);
  const [fornecedores, setFornecedores] = React.useState([]);
  const [unidades, setUnidades]         = React.useState([]);
  React.useEffect(() => {
    if (!avancado || !modalF3) return;
    api.get('/auxiliares/grupos').then(({ data }) => setGrupos(data || [])).catch(() => {});
    api.get('/auxiliares/subgrupos').then(({ data }) => setSubgrupos(data || [])).catch(() => {});
    api.get('/auxiliares/marcas').then(({ data }) => setMarcas(data || [])).catch(() => {});
    api.get('/auxiliares/fornecedores').then(({ data }) => setFornecedores(data || [])).catch(() => {});
    api.get('/produtos/unidades-em-uso').then(({ data }) => setUnidades(data || [])).catch(() => {});
  }, [avancado, modalF3]);

  // Modo seleção (Cadastro de Produtos): marca um a um ou todos da grade e o
  // Ok leva só os marcados — a tela navega apenas por eles.
  const [marcados, setMarcados] = React.useState(() => new Set());
  React.useEffect(() => { setMarcados(new Set()); }, [produtosF3]);
  const alternarMarcado = id => setMarcados(prev => {
    const n = new Set(prev);
    if (n.has(id)) n.delete(id); else n.add(id);
    return n;
  });
  const todosMarcados = produtosF3.length > 0 && marcados.size === produtosF3.length;
  const alternarTodos = () => setMarcados(todosMarcados ? new Set() : new Set(produtosF3.map(p => p.id)));

  const subgruposDoGrupo = filtrosF3.grupo_id
    ? subgrupos.filter(sg => String(sg.grupo_id) === String(filtrosF3.grupo_id))
    : subgrupos;

  if (!modalF3) return null;
  return (
        <div className={s.modalOverlay} onClick={fecharF3}>
          <div className={s.modalF3} onClick={e => e.stopPropagation()}>

            {/* Título */}
            <div className={s.modalTitleBar}>
              <span>
                {consultaOnly ? 'Consulta de Produtos' : avancado ? 'F3 — Busca Avançada de Produtos' : 'F3 — Busca de Produtos'}
                {tabela && (
                  <span style={{ marginLeft: 10, fontSize: 11, fontWeight: 'normal', opacity: 0.85 }}
                    title="Preços exibidos já consideram a tabela de preço do cliente selecionado">
                    💲 Tabela: {tabela.descricao}
                  </span>
                )}
              </span>
              <button className={s.modalClose} onClick={fecharF3}>✕</button>
            </div>

            {/* Área de filtros — só na Busca Avançada (Alteração em Massa).
                Nas demais telas o modal fica enxuto: grade + busca rápida. */}
            {avancado && (
            <div className={s.f3Filtros}>
              {/* Grid de campos */}
              <div className={s.f3FiltroGrid}>
                {[
                  ['Código',       'codigo',       'text'],
                  ['Descrição',    'descricao',    'text'],
                  ['Tributação',   'tributacao',   'text'],
                  ['Aplicação',    'aplicacao',    'text'],
                  ['Cód. barras',  'cod_barras',   'text'],
                  ['Aliq. ICMS',   'aliq_icms',    'text'],
                  ['NCM',          'ncm',          'text'],
                  ['Unidade',      'unidade',      'select-unidade'],
                  ['Plataforma',   'plataforma',   'select-plat'],
                ].map(([label, campo, tipo]) => (
                  <div key={campo} className={s.f3Campo}>
                    <label className={s.f3Label}>{label}:</label>
                    {tipo === 'select-plat' ? (
                      <select className={s.f3Input} value={filtrosF3[campo]}
                        onChange={e => setFiltro(campo, e.target.value)}>
                        <option value="">Todas</option>
                        <option value="loja">Loja</option>
                        <option value="ecommerce">E-commerce</option>
                        <option value="marketplace">Marketplace</option>
                      </select>
                    ) : tipo === 'select-unidade' ? (
                      <select className={s.f3Input} value={filtrosF3[campo]}
                        onChange={e => setFiltro(campo, e.target.value)}
                        title="Só lista unidades que algum produto já usa hoje">
                        <option value="">Todas</option>
                        {unidades.map(u => (
                          <option key={u.codigo} value={u.codigo}>
                            {u.codigo}{u.descricao ? ` — ${u.descricao}` : ''}
                          </option>
                        ))}
                      </select>
                    ) : (
                      <input className={s.f3Input} type="text"
                        placeholder={campo === 'tributacao' ? 'CST/CSOSN: 102, 500, 020…' : undefined}
                        title={campo === 'tributacao' ? 'Código do CST/CSOSN de ICMS na saída do produto (aceita com ou sem o zero à esquerda)' : undefined}
                        value={filtrosF3[campo]}
                        onChange={e => setFiltro(campo, e.target.value)} />
                    )}
                  </div>
                ))}

                {/* Grupo/Subgrupo/Marca/Fornecedor — select de verdade (antes
                    era um texto com um botão "…" decorativo que não abria
                    nada; não dava pra filtrar por eles sem saber o ID). */}
                <div className={s.f3Campo}>
                  <label className={s.f3Label}>Grupo:</label>
                  <select className={s.f3Input} value={filtrosF3.grupo_id}
                    onChange={e => { setFiltro('grupo_id', e.target.value); setFiltro('subgrupo_id', ''); }}>
                    <option value="">Todos</option>
                    {grupos.map(g => <option key={g.id} value={g.id}>{g.nome}</option>)}
                  </select>
                </div>
                <div className={s.f3Campo}>
                  <label className={s.f3Label}>Subgrupo:</label>
                  <select className={s.f3Input} value={filtrosF3.subgrupo_id}
                    onChange={e => setFiltro('subgrupo_id', e.target.value)}>
                    <option value="">Todos</option>
                    {subgruposDoGrupo.map(sg => <option key={sg.id} value={sg.id}>{sg.nome}</option>)}
                  </select>
                </div>
                <div className={s.f3Campo}>
                  <label className={s.f3Label}>Marca:</label>
                  <select className={s.f3Input} value={filtrosF3.marca_id}
                    onChange={e => setFiltro('marca_id', e.target.value)}>
                    <option value="">Todas</option>
                    {marcas.map(m => <option key={m.id} value={m.id}>{m.nome}</option>)}
                  </select>
                </div>
                <div className={s.f3Campo}>
                  <label className={s.f3Label}>Fornecedor:</label>
                  <select className={s.f3Input} value={filtrosF3.fornecedor_id}
                    onChange={e => setFiltro('fornecedor_id', e.target.value)}>
                    <option value="">Todos</option>
                    {fornecedores.map(f => <option key={f.id} value={f.id}>{f.nome}</option>)}
                  </select>
                </div>
              </div>

              {/* Checkboxes */}
              <div className={s.f3Checks}>
                {[
                  ['ver_inativos', 'Ver inativos'],
                  ['balanca',      'Balança'],
                  ['estoque_min',  'Estoque mínimo'],
                  ['estoque_neg',  'Estoque negativo'],
                  ['marcador',     'Marcador'],
                  ['sem_cest',     'Sem CEST'],
                  ['sem_ncm',      'Sem NCM'],
                  ['consignacao',  'Consignação'],
                  ['margem_zero',  'Margem zero'],
                  ['composto',     'Composto'],
                  ['servico',      'Serviços'],
                ].map(([campo, label]) => (
                  <label key={campo} className={s.f3CheckLabel}>
                    <input type="checkbox" checked={filtrosF3[campo]}
                      onChange={e => setFiltro(campo, e.target.checked)} />
                    {label}
                  </label>
                ))}
              </div>

              <div className={s.f3FiltrarRow}>
                <button className={s.f3BtnFiltrar}
                  onClick={() => buscarF3(filtrosF3, buscaRapidaF3)}>
                  Filtrar
                </button>
                <button className={s.f3BtnLimpar}
                  onClick={() => { setFiltrosF3(FILTROS_VAZIOS); setProdutosF3([]); setBuscaRapidaF3(''); }}>
                  Limpar
                </button>
                {buscandoF3 && <span className={s.f3Buscando}>Buscando…</span>}
              </div>
            </div>
            )}

            {/* Grade de produtos */}
            <div className={s.f3GridWrap}>
              <table className={s.f3Grid}>
                <thead>
                  <tr>
                    {selecao && (
                      <th style={{width:30, textAlign:'center'}}>
                        <input type="checkbox" checked={todosMarcados} disabled={!produtosF3.length}
                          onChange={alternarTodos} title="Marcar/desmarcar todos da grade" />
                      </th>
                    )}
                    <th style={{width:72}}>Código</th>
                    <th style={{width:135}}>Cód. barras</th>
                    <th>Descrição</th>
                    <th style={{width:100}}>Marca</th>
                    <th style={{width:64}}>UN</th>
                    <th style={{width:60}}>Tipo</th>
                    <th style={{width:80}} className={s.right}>Estoque</th>
                    <th style={{width:100}} className={s.right}>Preço R$</th>
                  </tr>
                </thead>
                <tbody>
                  {produtosF3.length === 0 && !buscandoF3 && (
                    <tr>
                      <td colSpan={selecao ? 9 : 8} className={s.f3Vazio}>
                        {Object.values(filtrosF3).some(v => v && v !== false)
                          ? 'Nenhum produto encontrado.'
                          : 'Use os filtros acima ou a busca rápida abaixo.'}
                      </td>
                    </tr>
                  )}
                  {produtosF3.map((p, idx) => (
                    <tr
                      key={p.id}
                      ref={idxF3 === idx ? linhaSelRef : null}
                      className={idxF3 === idx ? s.f3LinhaSel : ''}
                      onClick={() => setIdxF3(idx)}
                      onDoubleClick={() => !modoTodos && confirmarF3(p)}
                    >
                      {selecao && (
                        <td style={{textAlign:'center'}} onClick={e => e.stopPropagation()} onDoubleClick={e => e.stopPropagation()}>
                          <input type="checkbox" checked={marcados.has(p.id)} onChange={() => alternarMarcado(p.id)} />
                        </td>
                      )}
                      <td>{p.codigo_interno}</td>
                      <td>{p.codigo_barras || '—'}</td>
                      <td>{p.nome}</td>
                      <td>{p.marca_nome || '—'}</td>
                      <td>{p.unidade || ''}</td>
                      <td>{p.tipo || ''}</td>
                      <td className={s.right}>{p.estoque_atual != null ? Number(p.estoque_atual).toLocaleString('pt-BR', {minimumFractionDigits:3}) : '—'}</td>
                      <td className={s.right}>
                        {tipoMovFiscal?.usa_preco_custo ? (
                          <span style={{color:'#e65100'}}>{fmtBRL(p.preco_custo)}</span>
                        ) : (() => {
                          const precoBase   = parseFloat(p.preco_venda) || 0;
                          const precoTabela = calcularPrecoTabela(p, tabela);
                          const temAjuste   = tabela && Math.abs(precoTabela - precoBase) > 0.004;
                          return temAjuste ? (
                            <span title={`Preço de cadastro: ${fmtBRL(precoBase)}`}>
                              <span style={{ textDecoration: 'line-through', color: '#999', fontSize: '0.85em', marginRight: 4 }}>
                                {fmtBRL(precoBase)}
                              </span>
                              <span style={{ color: '#1565c0', fontWeight: 700 }}>{fmtBRL(precoTabela)}</span>
                            </span>
                          ) : fmtBRL(precoBase);
                        })()}
                      </td>
                    </tr>
                  ))}
                  {totalF3 > produtosF3.length && (
                    <tr>
                      <td colSpan={selecao ? 9 : 8} className={s.f3Vazio}>
                        Mostrando {produtosF3.length} de {totalF3.toLocaleString('pt-BR')} produtos — digite mais letras ou use os filtros para achar o item.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Rodapé do modal */}
            <div className={s.f3Rodape}>
              <div className={s.f3BuscaRapidaWrap}>
                <label className={s.f3Label} style={{whiteSpace:'nowrap'}}>Busca rápida:</label>
                <input
                  ref={buscaRapidaRef}
                  className={s.f3BuscaRapida}
                  placeholder="Nome (a partir de 3 letras) ou código…"
                  value={buscaRapidaF3}
                  onChange={handleBuscaRapidaF3}
                  // Enter busca na hora, mesmo com menos de 3 letras
                  onKeyDown={e => { if (e.key === 'Enter' && buscaRapidaF3.trim()) { e.preventDefault(); buscarF3(filtrosF3, buscaRapidaF3); } }}
                  title="Nome: busca a partir da 3ª letra. Código: busca desde o 1º dígito. Enter busca na hora."
                  autoComplete="off"
                />
              </div>
              <div className={s.f3BotoesRodape}>
                {!consultaOnly && !modoTodos && <button className={s.f3BtnNovo}>+ Novo produto</button>}
                {!consultaOnly && selecao && (
                  <button
                    className={s.f3BtnOk}
                    disabled={marcados.size === 0}
                    title="Leva só os produtos marcados — a navegação do cadastro fica restrita a eles"
                    onClick={() => confirmarSelecionados(produtosF3.filter(p => marcados.has(p.id)))}
                  >
                    {`Ok — usar ${marcados.size} selecionado(s)`}
                  </button>
                )}
                {!consultaOnly && (
                  <button
                    className={s.f3BtnOk}
                    disabled={modoTodos ? produtosF3.length === 0 : idxF3 === null}
                    onClick={() => modoTodos
                      ? confirmarTodos(produtosF3)
                      : (idxF3 !== null && confirmarF3(produtosF3[idxF3]))}
                  >
                    {modoTodos ? `Ok — usar ${produtosF3.length} produto(s)` : 'Ok'}
                  </button>
                )}
                <button className={s.f3BtnSair} onClick={fecharF3}>Sair</button>
              </div>
            </div>
          </div>
        </div>
  );
}
